/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import Effect from './Effect';

/** @hidden */
// tslint:disable-next-line:typedef
const ccclass = cc._decorator.ccclass;
/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** An effect for building in delays. */
@ccclass
export default class DelayEffect extends Effect
{
    /** Duration of the delay. */
    @property({ type: cc.Float, visible: true })
    private _duration: number = 0.0;

    /** Whether or not this effect should block its state. */
    @property({ override: true, visible: false })
    protected isBlocking: boolean = true;

    /** @hidden */
    private _curTime: number = 0.0;

    /** Executes the delay effect. */
    protected trigger = (): void =>
    {
        this._curTime = 0.0;
    }

    /** @hidden */
    protected update(dt: number): void
    {
        super.update(dt);

        if (!this.IsCurrentState()) { return; }

        let modDT: number = this.dtModRef.Value.Multiply(dt);
        this._curTime += modDT;
        if (this._curTime >= this._duration || this.isStopping)
        {
            this.complete();
        }
    }
}
